import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Link, Stack, Button, Drawer, Tooltip, Typography, CardActionArea, Card } from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// routes
import { PATH_DASHBOARD, PATH_DOCS } from '../../routes/paths';
// components
import Logo from '../../components/Logo';
import MyAvatar from '../../components/MyAvatar';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import sidebarConfig from './SidebarConfig';
import { DocIllustration } from '../../assets';
import useWallet from '../../hooks/useWallet';
import { fCurrency } from '../../utils/formatNumber';
import { analytics } from '../../contexts/FirebaseContext';
import DialogWallet from '../../components/_dashboard/wallet/DialogWallet';
import { useSelector } from 'react-redux';
import useAuthUsers from '../../hooks/useAuthUsers';
import useHostWallet from '../../hooks/useHostWallet';
import WalletView from '../../components/_dashboard/wallet/walletCard/WalletView';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.complex
    })
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[500_12]
}));

// ----------------------------------------------------------------------

IconCollapse.propTypes = {
  onToggleCollapse: PropTypes.func,
  collapseClick: PropTypes.bool
};

function IconCollapse({ onToggleCollapse, collapseClick }) {
  return (
    <Tooltip title="Mini Menu">
      <CardActionArea
        onClick={onToggleCollapse}
        sx={{
          width: 18,
          height: 18,
          display: 'flex',
          cursor: 'pointer',
          borderRadius: '50%',
          alignItems: 'center',
          color: 'text.primary',
          justifyContent: 'center',
          border: 'solid 1px currentColor',
          ...(collapseClick && {
            borderWidth: 2
          })
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'currentColor',
            transition: (theme) => theme.transitions.create('all'),
            ...(collapseClick && {
              width: 0,
              height: 0
            })
          }}
        />
      </CardActionArea>
    </Tooltip>
  );
}

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const [openWallet, setOpenWallet] = useState(false);
  const { pathname } = useLocation();
  // const { user } = useAuth();
  const { currentUser } = useAuthUsers();

  // console.log('verificando', currentUser);
  // const { roleName } = useRole();
  const { saldoServicios, saldoPaqueteria, saldoRecarga } = useWallet();
  const navigate = useNavigate();
  const { actualRol } = useSelector((state) => state.dagpacketRoles);

  const handleNavigate = () => {
    // navigate('/dashboard/cotizaciones/wallet');
    setOpenWallet(true);
    // analytics.logEvent('wallet', {
    //   user_id: user.id
    // });
  };

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Stack
        spacing={3}
        sx={{
          px: 2.5,
          pt: 3,
          pb: 2,
          ...(isCollapse && {
            alignItems: 'center'
          })
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>
            {/* <Logo /> */}
            <img width="90%" src="/favicon/dagPacket-logo.png" alt="" />
          </Box>

          <MHidden width="lgDown">
            {!isCollapse && <IconCollapse onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />}
          </MHidden>
        </Stack>

        {isCollapse ? (
          <MyAvatar sx={{ mx: 'auto', mb: 2 }} />
        ) : (
          <>
            <AccountStyle>
              <Link underline="none" component={RouterLink} to={PATH_DASHBOARD.user.account}>
                <Box display="flex" alignItem="center">
                  <MyAvatar />
                  <Box sx={{ ml: 2 }}>
                    <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                      {currentUser?.displayName}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {currentUser?.role} -{' '}
                      {currentUser?.contratoLicenciatario === 'contrato_2' ? 'Inmediato' : 'Tradicional'}
                    </Typography>
                  </Box>
                </Box>
              </Link>
              {actualRol?.hasWallet && (
                <WalletView handleNavigate={handleNavigate} />
                // <Card onClick={handleNavigate} sx={{ padding: '10px', cursor: 'pointer', marginTop: '10px' }}>
                //   <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
                //     <Typography fontSize="13px" variant="subtitle2">
                //       Saldo servicios:
                //     </Typography>
                //     <Typography fontSize="14px">{fCurrency(saldoServicios)}</Typography>
                //   </Box>
                //   <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
                //     <Typography fontSize="13px" variant="subtitle2">
                //       Saldo paqueteria:
                //     </Typography>
                //     <Typography fontSize="14px">{fCurrency(saldoPaqueteria)}</Typography>
                //   </Box>
                //   <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
                //     <Typography fontSize="13px" variant="subtitle2">
                //       Saldo recarga:
                //     </Typography>
                //     <Typography fontSize="14px">{fCurrency(saldoRecarga)}</Typography>
                //   </Box>
                // </Card>
              )}
              <DialogWallet open={openWallet} onClose={setOpenWallet} />
            </AccountStyle>

            {actualRol?.id === 'cajero' && <HostWallet currentUser={currentUser} handleNavigate={handleNavigate} />}
          </>
        )}
      </Stack>

      <NavSection navConfig={sidebarConfig} isShow={!isCollapse} />

      <Box sx={{ flexGrow: 1 }} />

      {!isCollapse && (
        <Stack spacing={3} alignItems="center" sx={{ px: 5, pb: 5, mt: 10, width: 1, textAlign: 'center' }}>
          <DocIllustration sx={{ width: 1 }} />

          <div>
            <Typography gutterBottom variant="subtitle1">
              Hi, {currentUser?.displayName}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Need help?
              <br /> Please check our docs
            </Typography>
          </div>
          <Button href="https://wa.me/3329728996" target="_blank" variant="contained">
            Contacto
          </Button>
        </Stack>
      )}
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? COLLAPSE_WIDTH : DRAWER_WIDTH
        },
        ...(collapseClick && {
          position: 'absolute'
        })
      }}
    >
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              ...(isCollapse && {
                width: COLLAPSE_WIDTH
              }),
              ...(collapseHover && {
                borderRight: 0,
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
                boxShadow: (theme) => theme.customShadows.z20,
                bgcolor: (theme) => alpha(theme.palette.background.default, 0.88)
              })
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}

function HostWallet({ currentUser, handleNavigate }) {
  const { id, hostUser } = currentUser;
  const { hostWallet } = useHostWallet();
  return (
    <Card sx={{ padding: '10px', cursor: 'pointer' }} onClick={handleNavigate}>
      {hostUser ? (
        <>
          <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
            <Typography fontSize="13px" variant="subtitle2">
              Saldo servicios:
            </Typography>
            <Typography fontSize="14px">{fCurrency(hostWallet?.saldoServicio)}</Typography>
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
            <Typography fontSize="13px" variant="subtitle2">
              Saldo paqueteria:
            </Typography>
            <Typography fontSize="14px">{fCurrency(hostWallet?.saldoPaqueteria)}</Typography>
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
            <Typography fontSize="13px" variant="subtitle2">
              Saldo recarga:
            </Typography>
            <Typography fontSize="14px">{fCurrency(hostWallet?.saldoRecarga)}</Typography>
          </Box>
        </>
      ) : (
        <Typography variant="subtitle2" fontSize="13px">
          Saldo no disponible
        </Typography>
      )}
    </Card>
  );
}
